export class SortColumn {
    name?: string
    type?: 'asc' | 'desc'   
    constructor(name?: string, type?: 'asc' | 'desc'){
        this.name = (name) ? name : undefined;
        this.type = (type) ? type : undefined;
    }
}